import type {Maybe} from '@/types'

export const CUSTOMER_ROLES = ['VIEWER', 'USER', 'HOTEL_ADMIN']
export const ADMIN_ROLES = ['ADMIN', 'SUPER_ADMIN']
export const ROLES = [...CUSTOMER_ROLES, ...ADMIN_ROLES]

export const getHighestRole = (roles: string[]): Maybe<string> => {
  if (roles.length === 0) {
    return null
  }

  return roles.reduce((highestRole, role) => {
    if (ROLES.indexOf(role) > ROLES.indexOf(highestRole)) {
      return role
    }

    return highestRole
  }, 'VIEWER')
}

export const getLowerRoles = (role: string) => {
  const idx = ROLES.indexOf(role)
  if (idx === -1) return []

  return ROLES.slice(0, idx)
}
